<template>
  <footer class="footer">
    <div class="container footer-content">
      <p>&copy; 2024 Passguard9000. All rights reserved.</p>
      <ul class="footer-links">
        <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
        <li>
          <router-link to="/terms-and-conditions"
            >Terms & Conditions</router-link
          >
        </li>
        <li>
          <p>support@passguard9000.com</p>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
@import "@/styles/components/Footer.scss";
</style>
